import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcPlaylist = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 15"
    width={18}
    height={15}
    fill="none"
    {...props}
  >
    <path
      d="M0 1.625H15"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="M0 6.875H6.375"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="M0 12.125H6.375"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="M16.1238 8.90845C16.2906 9.00466 16.2906 9.24534 16.1238 9.34155L9.37493 13.2351C9.20826 13.3313 9 13.211 9 13.0186L9 4.79856L11.5417 6.26493L16.1238 8.90845Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIcPlaylist;
